export class InteractionEventDTO {
  alisConvId: any;
  pinv: any='U';
  callerType: any;
  callMode: any;
  udpId: any;
  agentId: any;
  callStartTimestamp: any;
  callEndTimestamp: any;

}
